import { Component } from 'preact';
import style from './style';
import { API } from '@globals';

import { Tab, Tabs } from '@components/tabs';
import DropDownCard from '@components/dropdowncard';
import analytics from '@analytics';
import I18n from '@i18n';

const selectCity = (item_name, index) => {
  analytics({
    event: 'select_content',
    content_type: 'Regular link',
    content_id: item_name,
    index,
  });
};
let cities = [];
export class CityList extends Component {
  state = { cities };
  fetchCities = () => {
    this.context.auth.request(`${API}/cities.json`).then(allCities => {
      cities = allCities;
      this.setState({ cities });
    });
  };
  componentDidMount() {
    if (!this.state.cities.length) {
      this.fetchCities();
    }
  }
  render(props, { cities = [] }, { lang, events }) {
    return (
      <ul class={`${style.cityPromoList} contain`}>
        {cities
          .filter(item =>
            this.props.country ? this.props.country === item.country_code : true
          )
          .map((city, index) => (
            <li class={style.singleCity}>
              <a
                href={`/${lang}/${city.slug}`}
                class={style.citySelectionLink}
                onClick={e => {
                  if (props.onlyChangeCity) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    events.emit('city', city.title);
                  }
                  if (props.onClose) props.onClose(city.title);
                  selectCity(city.title, index);
                }}
              >
                <h5>{city.title}</h5>
              </a>
            </li>
          ))}
      </ul>
    );
  }
}

export class CityTabs extends Component {
  render(props, state, { lang }) {
    const cities = [
      <Tab tab={I18n.t('Finland')}>
        <CityList
          country={'FI'}
          onClose={props.onClose}
          onlyChangeCity={props.onlyChangeCity}
        />
      </Tab>,
      <Tab tab={I18n.t('Estonia')}>
        <CityList
          country={'EE'}
          onClose={props.onClose}
          onlyChangeCity={props.onlyChangeCity}
        />
      </Tab>,
    ];
    return (
      <div class={style.mainCitySelector}>
        <div class={style.citySelectorTabs}>
          <Tabs label={I18n.t('Choose your city')}>
            {lang === 'ee' ? cities.reverse() : cities}
          </Tabs>
        </div>
      </div>
    );
  }
}

export class CitySelector extends Component {
  render(props) {
    return (
      <DropDownCard
        show={props.show}
        onClose={props.onClose}
        anchor={props.anchor}
      >
        <CityTabs
          onlyChangeCity={props.onlyChangeCity}
          onClose={props.onClose}
        />
      </DropDownCard>
    );
  }
}

export default CitySelector;



// WEBPACK FOOTER //
// ./components/cityselector/index.js